export const CONTACT_INFO = {
  email: "hello@upfellow.com",
  telegramChannelName: "upfellow_pub",
};

export const NEW_PLATFORM = {
  name: "OuTreX.ai",
  url: "https://short.upfellow.com/outrex",
};

export const AUTH0_TOKEN_ROLES_CLAIM = "https://upfellow.com/roles";

export const ROLES = {
  ADMIN: "admin",
  MEMBER: "member",
  MEMBER_PREMIUM: "memberPremium",
};

export const hasMemberAccess = (role) =>
  role === ROLES.MEMBER || role === ROLES.MEMBER_PREMIUM;
